export type LastMonthMembershipAnnouncementCheckboxKey =
  | 'healing_sheet'
  | 'image_1'
  | 'image_2'
  | 'sale_case'
  | 'rejected_image'
  | 'rejected_sale_case';

export type LastMonthMembershipAnnouncementCheckboxState = Record<LastMonthMembershipAnnouncementCheckboxKey, boolean>;

export interface LastMonthMembershipAnnouncementCheckboxOption {
  key: LastMonthMembershipAnnouncementCheckboxKey;
  label: string;
}

export const LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_OPTIONS: LastMonthMembershipAnnouncementCheckboxOption[] = [
  { key: 'healing_sheet', label: 'ヒアリングシート' },
  { key: 'image_1', label: '写真1枚以上' },
  { key: 'image_2', label: '写真2枚以上' },
  { key: 'sale_case', label: '売却実績' },
  { key: 'rejected_image', label: '【差し戻し】写真' },
  { key: 'rejected_sale_case', label: '【差し戻し】売却実績' },
];

export const LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_INITIAL_CHECKBOX_STATE: LastMonthMembershipAnnouncementCheckboxState =
  LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_OPTIONS.reduce(
    (acc, option) => ({ ...acc, [option.key]: false }),
    {} as LastMonthMembershipAnnouncementCheckboxState,
  );

export const LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_LABELS: Record<
  LastMonthMembershipAnnouncementCheckboxKey,
  string
> = LAST_MONTH_MEMBERSHIP_ANNOUNCEMENT_CHECKBOX_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option.key]: option.label }),
  {} as Record<LastMonthMembershipAnnouncementCheckboxKey, string>,
);
